import { Action } from '@ngrx/store';
import {
  WeeeError,
  WeeeSubmitRequest,
  WeeeSuccess
} from '~shared/modules/weee-landing-page/models/weee-feedback.model';

export enum WeeeFeedabackActionTypes {
  SUBMIT_WEEE_USER_SELECTION = '[Weee Feedback] Submit the WEEE user selection',
  SUBMIT_WEEE_USER_SELECTION_SUCCESS = '[Weee Feedback] Submit the WEEE user selection success',
  SUBMIT_WEEE_USER_SELECTION_FAILURE = '[Weee Feedback] Submit the WEEE user selection failure',
}

export class SubmitWeeeUserSelection implements Action {
  readonly type = WeeeFeedabackActionTypes.SUBMIT_WEEE_USER_SELECTION;

  constructor(public payload: WeeeSubmitRequest) {
  }
}

export class SubmitWeeeUserSelectionSuccess implements Action {
  readonly type = WeeeFeedabackActionTypes.SUBMIT_WEEE_USER_SELECTION_SUCCESS;

  constructor(public payload: WeeeSuccess) {
  }
}

export class SubmitWeeeUserSelectionError implements Action {
  readonly type = WeeeFeedabackActionTypes.SUBMIT_WEEE_USER_SELECTION_FAILURE;

  constructor(public payload: WeeeError) {
  }
}

export type WeeeFeedabackActionUnion =
  SubmitWeeeUserSelection
  | SubmitWeeeUserSelectionSuccess
  | SubmitWeeeUserSelectionError;
